import { RootPagePaperLinkBox } from "@app/components/RootPage";
import { Typography } from "@mui/material";
import { formatDate } from "@app/utils";
import { useLatestSimulationDate } from "@app/pages/assetAllocation/useLatestSimulationDate";

export const SourceDataAsOf = () => {
  const latestSimulationDate = useLatestSimulationDate();

  return (
    <RootPagePaperLinkBox sx={{ width: "100%" }}>
      {latestSimulationDate.latestSimulationDate && (
        <Typography
          sx={{ ml: "auto", alignSelf: "center", color: "white", mb: 1.5 }}
          variant="mediumItalic"
        >{`Source Data as of: ${formatDate(
          latestSimulationDate.latestSimulationDate,
        )}`}</Typography>
      )}
    </RootPagePaperLinkBox>
  );
};
